import React from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import signalImage from "../assets/signal.png";

const SignalCard = ({ onExitStart }) => {
  const navigate = useNavigate();

  const handleSignalClick = () => {
    if (onExitStart) {
      onExitStart();
    } else {
      navigate("/signal");
    }
  };

  return (
    <div
      className="bg-gray-900 text-white rounded-3xl h-full overflow-hidden cursor-pointer relative"
      onClick={handleSignalClick}
    >
      {/* 이미지 컨테이너 */}
      <div className="absolute inset-0 z-0 flex items-center justify-center">
        <div className="w-full h-full overflow-hidden flex items-center justify-center">
          <img
            src={signalImage}
            alt="Signal background"
            className="object-contain"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
            }}
          />
        </div>
      </div>

      {/* 반투명 오버레이 - 투명도 높임 */}
      <div className="absolute inset-0 bg-gray-900 opacity-75 z-10"></div>

      {/* 콘텐츠 */}
      <div className="relative z-20 flex flex-col justify-between h-full p-6 md:p-8">
        {/* 데스크톱 레이아웃 */}
        <div className="hidden lg:block">
          <h3 style={{ fontSize: "14px" }} className="mb-2 md:mb-4">
            SIGNAL SERVICE
          </h3>
          <div className="text-white leading-snug">
            <h2 className="text-white mb-4">
              <span style={{ fontSize: "80px" }}>Real-time</span>
            </h2>
            <h2 className="text-white mb-4">
              <span style={{ fontSize: "60px" }}>Trading Signals</span>
            </h2>
          </div>
        </div>

        {/* 모바일 레이아웃 */}
        <div className="lg:hidden flex flex-col justify-center items-center h-full">
          <h2 className="text-white text-3xl font-bold text-center mb-2">
            Signal Service
          </h2>
          <p className="text-white text-center text-sm opacity-80">
            Real-time trading signals and alerts
          </p>
        </div>

        {/* 버튼 */}
        <div className="flex items-end justify-center lg:justify-start">
          <button className="bg-white text-black px-8 py-2 md:px-10 md:py-3 rounded-full flex items-center text-lg md:text-xl font-semibold transition-all duration-300 ease-in-out shadow-lg hover:bg-gray-200 hover:shadow-xl">
            Signal
            <ChevronRight className="ml-5 w-6 h-7 md:w-7 md:h-7" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignalCard;
